<kuv-loading></kuv-loading>
<kuv-alert></kuv-alert>
<div class="container-fluid p-5">
    <h3>Gestión de Categorías</h3>
    <div class="btn btn-primary my-2" (click)="agregar()"><i class="fas fa-plus-circle me-2"></i>Registrar Nueva
        Categoría</div>
    <kuv-lazy-table [url]="config.apiUrl + 'categoria/index/'" [urlExcel]="config.apiUrl + 'categoria/excel'"
        [headersBlob]="sesion.headersBlob" [columnas]="columnas" [acciones]="acciones" [reloadEmitter]="reloadEmitter"
        [hasShadow]="true" [isRounded]="true" [headers]="sesion.headers" [filtros]="filtros"></kuv-lazy-table>
</div>